function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
  root: {
    position: "absolute",
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    overflowY: "scroll",
    fontFamily: "Akkurat Mono",
    fontVariantLigatures: "none",
    fontSize: "14px",
    lineHeight: 1.5,
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.secondary,
    whiteSpace: "pre-wrap",
    wordWrap: "break-word",
    padding: theme.spacing(1),
    "& .string": {
      color: theme.palette.code.string
    },
    "& .number": {
      color: theme.palette.code.number
    },
    "& .boolean": {
      color: theme.palette.code.boolean
    }
  }
}));

const PreviewCodeRender = (_ref) => {
  let theme = _ref.theme,
      language = _ref.language,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["theme", "language", "children"]);

  const classes = useStyles();
  return React.createElement("pre", {
    className: classes.root,
    "data-theme": theme,
    "data-language": language
  }, children);
};

export default PreviewCodeRender;